/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CdkDropList } from '@angular/cdk/drag-drop';
import { Directive } from '@angular/core';
import { noop } from 'lodash';

/**
 * This directive implements monkey patch to prevening moving of draggable element.
 * This monkey patch MUST BE REMOVED as soon as this feature will be supported by @angular/cdk.
 * The status of this problem can be tracked in the following related issues
 * https://github.com/angular/material2/issues/13100
 * https://github.com/angular/material2/issues/14261
 */
@Directive({
  selector: '[ghMonkeyDropListNoMove]',
})
export class MonkeyDropListNoMoveDirective {
  constructor(private dropList: CdkDropList) {
    // do nothing when we enter drop list
    dropList._dropListRef.enter = noop;
    dropList._dropListRef._sortItem = noop;
    dropList._dropListRef['_reset'] = noop;
    dropList._dropListRef.exit = noop;
  }
}
